import { WsFallbackConfig, WsFallbackRouteParams } from '@/ws/fallback';
import { caseQueryKeys } from '@/queries/case';
import { queryClient } from '@/queries';
import { notificationsQueryKeys } from '@/queries/notification/notifications.keys';
import { routePlannerQueryKeys } from '@/queries/route-planner/route-planner.keys';
import { refetchRouteLogistics } from '@/queries/route-planner/utils';
import { getGroundTripsList } from '@/queries/drive-service';
import { Case } from '@/api/apis/case';
import { LogisticsProjectionType } from '@/api/apis/route';

const refetchCaseLogisticsAndGroundTrips = async ({ caseId }: WsFallbackRouteParams) => {
  if (!caseId) return;

  const caseData = queryClient.getQueryData<Case>(caseQueryKeys.getItem(caseId));
  const logisticsId = caseData?.logisticsReference?.id;
  if (!logisticsId) return;

  await refetchRouteLogistics(logisticsId);

  const logisticsData = queryClient.getQueryData<LogisticsProjectionType>(
    routePlannerQueryKeys.getLogistics(logisticsId),
  );
  if (logisticsData?.groundTripIds?.length) {
    await getGroundTripsList(logisticsData.groundTripIds);
  }
};

export const wsFallbackConfig: WsFallbackConfig = {
  routeQueries: {
    '/case/:caseId/*': ({ caseId }) => [caseQueryKeys.getItem(caseId)],
    '/bulk-assignment': [caseQueryKeys.getBulkAssignmentCases(), caseQueryKeys.getBulkAssignmentStatus()],
  },
  customRefetchers: {
    '/case/:caseId/*': refetchCaseLogisticsAndGroundTrips,
  },
  alwaysOnQueries: [notificationsQueryKeys.getList(), notificationsQueryKeys.getInfiniteList()],
};
